import { BACKGROUND_VIDEOS } from '@/lib/marketing-config'

// A film made with Martini, blurred and dimmed, as a backdrop for a heading.
// Fills its nearest positioned ancestor; the caller fades the edges into its own background.
// The dimming is the video's own filter, not a black layer on top: the video is composited on its
// own, so a separate overlay painted a beat later on scroll and the film flashed bright first.
// ponytail: loads with the page; lazy-load on scroll if it shows up in page-weight measurements.
export function FilmBackdrop({ film = 0, dim = 0.55, blur = 12 }: { film?: number; dim?: number; blur?: number }) {
  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      preload="none"
      aria-hidden
      className="absolute inset-0 h-full w-full scale-110 object-cover"
      style={{ filter: `blur(${blur}px) brightness(${1 - dim})` }}
    >
      <source src={BACKGROUND_VIDEOS[film % BACKGROUND_VIDEOS.length].src} type="video/mp4" />
    </video>
  )
}
